import type { ImageField } from "@prismicio/client"
import classNames from "classnames"
import React from "react"

import { useTranslation } from "@bounce/i18n"
import type { Nullable } from "@bounce/util"

import { AppAggregateRating } from "@/components/Generic/AppAggregateRating/AppAggregateRating"
import { FeaturedReviewCard } from "@/components/Generic/Reviews/FeaturedReviewCard/FeaturedReviewCard"
import type { AggregateRating } from "@/libs/bounce/aggregateRating"
import type { Review } from "@/utils/reviews"

export type HeroProps = {
  aggregateRating: AggregateRating
  cityImage: Nullable<ImageField>
  featuredReview: Review
  className?: string
}

export const Hero = ({ aggregateRating, cityImage, featuredReview, className }: HeroProps) => {
  const { t } = useTranslation("marketing-generic")

  return (
    <header className={classNames("mx-auto flex w-full max-w-screen-xl flex-col px-6 pt-10 md:pt-28", className)}>
      <AppAggregateRating
        {...aggregateRating}
        textClassName="paragraph2"
        starClassName="mb-0.5 md:mb-0 size-4 md:size-5"
      />
      <h1 className="title1 mt-2 break-words text-black">
        {t("screen.reviews.headerTitle", "What our customers say")}
      </h1>
      <FeaturedReviewCard review={featuredReview} imageSrc={cityImage} className="mt-10 md:mt-12" />
    </header>
  )
}
